export const Formatter = {
    toDate, toDayName, toMonthName,getMonth, toNumber, toCurrency
};

function toDate(props) {
    if (!props || props === null || props === "") return null
    if (props.substring(0, 10) !== '0001-01-01') {
        return props.substring(0, 10)
    }
    else
        return null
}
function toDayName(props) {
    return ["","Poniedziałek","Wtorek","Środa","Czwartek","Piątek","Sobota","Niedziela"][props];
}
function toMonthName(props) {
   return ["","Styczeń","Luty","Marzec","Kwiecień","Maj","Czerwiec","Lipiec","Sierpień","Wrzesień","Październik","Listopad","Grudzień"][props];
}
function getMonth(props) {
    return [{id: 1, name:"Styczeń"},{id:2, name:"Luty"},{id:3, name:"Marzec"},{id:4, name:"Kwiecień"},{id:5, name:"Maj"},{id:6, name:"Czerwiec"},{id:7, name:"Lipiec"},{id:8, name:"Sierpień"},{id:9, name:"Wrzesień"},{id:10, name:"Październik"},{id:11, name:"Listopad"},{id:12, name:"Grudzień"}];
 }

function toNumber(props) {
    return new Intl.NumberFormat('pl-PL', { minimumFractionDigits: 2 }).format(props)
}

function toCurrency(props) {
    return new Intl.NumberFormat('pl-PL', { style: 'currency', currency: 'PLN', minimumFractionDigits: 2 }).format(props)
}